import { useState } from 'react';
import { AppShell } from './AppShell';
import { DailyStats } from './DailyStats';
import { DataProvider } from './data/repositories';
import { ErrorBoundary } from './ErrorBoundary';
import { InstallHint } from './InstallHint';
import { UpdateBanner } from './UpdateBanner';
import { OnboardingScreen } from '@features/settings/OnboardingScreen';
import { readPreference, writePreference } from '@core/settings/preferences';

/** Первый запуск показывается **один раз**: отметка живёт рядом с прочими настройками. */
const SEEN_KEY = 'onboarding.seen';

/**
 * Приложение целиком: данные, каркас навигации и две плашки поверх — подсказка
 * установки и предложение обновиться.
 *
 * Первый запуск стоит **перед** данными: он ничего из базы не показывает, а ждать
 * открытия хранилища ради экрана с четырьмя абзацами незачем.
 */
export function App() {
  const [seen, setSeen] = useState(() => readPreference(SEEN_KEY) === 'yes');

  /*
   * Плашка обновления рисуется и на первом запуске.
   *
   * В ней живёт регистрация service worker, а значит и вся предзагрузка оболочки.
   * Пока она стояла только за первым запуском, приложение не кэшировалось до тех пор,
   * пока юрист не нажмёт «Создать первое дело»: закрыл экран приветствия — остался
   * без офлайна. Поймано прогоном 05.09.2026 — `serviceWorker.ready` не наступал.
   */
  if (!seen) {
    return (
      <ErrorBoundary>
        <OnboardingScreen
          onStart={() => {
            writePreference(SEEN_KEY, 'yes');
            setSeen(true);
          }}
        />
        <UpdateBanner />
      </ErrorBoundary>
    );
  }

  /*
   * Рубеж стоит **снаружи** провайдера данных, а не внутри.
   *
   * Внутри он не поймал бы падение самого провайдера — а это ровно тот код, который
   * открывает базу и переоткрывает её после фона, то есть самый вероятный источник
   * белого экрана.
   */
  return (
    <ErrorBoundary>
      <DataProvider>
        <AppShell />
        <DailyStats />
        <InstallHint />
        <UpdateBanner />
      </DataProvider>
    </ErrorBoundary>
  );
}
